export default __webpack_public_path__ + "static/media/msg.e50ac8a6.svg";